import React, { useCallback } from 'react';
import Template from './normal';

export default React.memo((props) => {
    const { operatorItem, changeInputValue, type, disabled } = props;

    const changeHandle = useCallback(
        (v) => {
            changeInputValue(operatorItem, 'aiModel', v.aiModel);
            changeInputValue(operatorItem, 'aiBatchQa', v.aiBatchQa);
            changeInputValue(operatorItem, 'ticketRelateQa', v.ticketRelateQa);
        },
        [changeInputValue, operatorItem]
    );

    return (
        <Template
            value={{
                aiModel: operatorItem.operatorList?.[0]?.param?.aiModel,
                aiBatchQa: operatorItem.operatorList?.[0]?.param?.aiBatchQa,
                ticketRelateQa: operatorItem.operatorList?.[0]?.param?.ticketRelateQa,
            }}
            onChange={changeHandle}
            type={type}
            disabled={disabled}
        />
    );
});
